module.exports = __webpack_public_path__ + "img/plus.f1c25039.svg";